import React, { Component } from "react";
import "./ScorerApp.css"

class ScorerApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scoreVal: "0"
        };

        this.handleClickNum = this.handleClickNum.bind(this);
        this.handleClickDelete = this.handleClickDelete.bind(this);
        this.handleClickClear = this.handleClickClear.bind(this);
        this.addCommas = this.addCommas.bind(this);
    }
    addCommas(numStr) {
        return parseInt(numStr, 10).toLocaleString();
    }
    handleClickNum(event) {
        const clickVal = event.target.className.charAt(event.target.className.length -1);
        this.setState((prevState) => {
            if (prevState.scoreVal.length < 15) {
                var newVal;
                if (parseInt(prevState.scoreVal, 10) === 0) {
                    newVal = clickVal;
                } else {
                    newVal = prevState.scoreVal + clickVal;
                }
                newVal = newVal.length > 3 ? this.addCommas(newVal.replace(/,/g, "")) : newVal;
                return {
                    scoreVal: newVal
                };
            } else {
                return {
                    scoreVal: prevState.scoreVal
                };
            }
        });

    }
    handleClickClear(event) {

        this.setState((prevState) => {
            return {
                scoreVal: "0"
            };
        });

    }
    handleClickDelete(event) {
        
        this.setState((prevState) => {
            
            var newVal = prevState.scoreVal.length > 1 ? prevState.scoreVal.substr(0, prevState.scoreVal.length - 1) : "0";
            newVal = newVal.length > 3 ? this.addCommas(newVal.replace(/,/g, "")) : newVal;
            return {
                scoreVal: newVal
            };
        });

    }
    renderScoreDisplay() {
        return (
            <label className="score-display">
                {this.state.scoreVal}
            </label>
        )

    }
    renderNumBtn(num) {
        return (
            <button className={"num-btn-" + num} onClick={this.handleClickNum}>
                {num}
            </button>
        )

    }
    renderClearBtn() {
        return (
            <button className="clear-btn" onClick={this.handleClickClear}>
                C
            </button>
        )

    }
    renderDeleteBtn() {
        return (
            <button className="delete-btn" onClick={this.handleClickDelete}>
                D
            </button>
        )

    }
    render() {
        return (
            <div className="scorer-app">
                {this.renderScoreDisplay()}
                <div className="top-row">
                    {this.renderNumBtn("9")}
                    {this.renderNumBtn("8")}
                    {this.renderNumBtn("7")}
                </div>
                <div className="middle-row">
                    {this.renderNumBtn("6")}
                    {this.renderNumBtn("5")}
                    {this.renderNumBtn("4")}
                </div>
                <div className="bottom-row">
                    {this.renderNumBtn("3")}
                    {this.renderNumBtn("2")}
                    {this.renderNumBtn("1")}
                </div>
                <div className="function-row">
                    {this.renderClearBtn()}
                    {this.renderNumBtn("0")}
                    {this.renderDeleteBtn()}
                </div>
            </div>
        );
    }
}

export default ScorerApp;


// WEBPACK FOOTER //
// ./src/ScorerApp.js